export default __webpack_public_path__ + "static/german-poster-9960cfd1a10e3b20eca615ed20df36df.png";